import { createContext, useContext, useEffect, useState } from "react";

const TRANSLATIONS = {
  el: {
    "nav.home": "Αρχική",
    "nav.categories": "Κατηγορίες",
    "nav.contact": "Επικοινωνία",
    "nav.favorites": "Αγαπημένα",
    "nav.map": "Χάρτης",
    "nav.admin": "Διαχείριση",
    "nav.dashboard": "Πίνακας",
    "nav.searchPlaceholder": "Αναζήτηση δραστηριότητας...",

    "home.title": "Βρες αυτό που σου ταιριάζει",
    "home.subtitle": "Διάλεξε κατηγορία και ανακάλυψε τοπικές δραστηριότητες & εκδηλώσεις.",
    "home.quickSearch": "Γρήγορη αναζήτηση",
    "home.allCities": "Όλες οι πόλεις",
    "home.allActivities": "Όλες οι δραστηριότητες",
    "home.allSports": "Όλα τα αθλήματα",
    "home.results": "Αποτελέσματα",
    "home.noResults": "Δεν βρέθηκαν αποτελέσματα για τα κριτήρια σας.",
    "home.offer": "Προσφορά",
    "home.partnerTitle": "Γίνε συνεργάτης",
    "home.partnerText": "Η επιχείρησή σου σε ένα νέο ψηφιακό οικοσύστημα. Παρουσίασε τις υπηρεσίες σου και σύνδεσε το κοινό με αυτό που προσφέρεις.",
    "home.partnerCta": "Μάθε περισσότερα",
    "home.appTitle": "Το SkillCity πάντα μαζί σου.",
    "home.appSubtitle": "Ανακάλυψε δραστηριότητες, υπηρεσίες και επιλογές για παιδιά και ενήλικες, όπου κι αν βρίσκεσαι.",
    "home.qrTitle": "Πάρε το SkillCity μαζί σου",
    "home.qrText": "Κατέβασε την εφαρμογή δωρεάν στο κινητό σου.",

    "footer.tagline": "Τοπικές δραστηριότητες & εκδηλώσεις",
    "footer.follow": "Ακολούθησέ μας",
    "footer.followTags": "Νέα • Δραστηριότητες • Εκδηλώσεις • Προτάσεις",

    "contact.eyebrow": "Επικοινωνία",
    "contact.title": "Ελάτε σε επαφή",
    "contact.subtitle": "Έχετε ερώτηση ή θέλετε να καταχωρήσετε τη δραστηριότητά σας; Στείλτε μας μήνυμα.",
    "contact.emailLabel": "Email",
    "contact.areaLabel": "Περιοχή",
    "contact.areaValue": "Ελλάδα",
    "contact.hoursLabel": "Ώρες",
    "contact.hoursValue": "Δευτ–Παρ 09:00–18:00",

    "form.name": "Όνομα",
    "form.email": "Email",
    "form.subject": "Θέμα",
    "form.message": "Μήνυμα",
    "form.send": "Αποστολή μηνύματος",
    "form.sending": "Αποστολή...",
    "form.success": "Το μήνυμά σας στάλθηκε! Θα επικοινωνήσουμε σύντομα.",
    "form.fail": "Αποτυχία αποστολής",
    "subj.general": "Γενική ερώτηση",
    "subj.listing": "Καταχώρηση δραστηριότητας",
    "subj.partnership": "Συνεργασία / Χορηγία",
    "subj.issue": "Αναφορά προβλήματος",

    "detail.back": "Πίσω",
    "detail.views": "προβολές",
    "detail.schedule": "Εβδομαδιαίο Πρόγραμμα",
    "detail.reviews": "Αξιολογήσεις",
    "detail.addReview": "Προσθήκη",
    "detail.noReviews": "Δεν υπάρχουν ακόμη αξιολογήσεις. Γίνετε ο πρώτος!",
    "detail.location": "Τοποθεσία",
    "detail.contactHeading": "Επικοινωνία",
    "detail.notFound": "Η δραστηριότητα δεν βρέθηκε.",
    "detail.return": "← Επιστροφή",
    "detail.reviewTitle": "Προσθήκη αξιολόγησης",
    "detail.reviewName": "Όνομα",
    "detail.reviewRating": "Βαθμολογία",
    "detail.reviewComment": "Σχόλιο",
    "detail.submit": "Υποβολή",
    "detail.reviewAdded": "Η αξιολόγησή σας καταχωρήθηκε!",
    "detail.tabAbout": "Περιγραφή",
    "detail.tabDepartments": "Τμήματα / Υπηρεσίες",
    "detail.tabSchedule": "Πρόγραμμα",
    "detail.tabFacilities": "Εγκαταστάσεις",
    "detail.tabPhotos": "Φωτογραφίες",
    "detail.tabNews": "Νέα / Εκδηλώσεις",
    "detail.tabOffers": "Προσφορές",
    "detail.viewAllPhotos": "Δείτε όλες τις φωτογραφίες",
    "detail.reviewsWord": "αξιολογήσεις",
    "detail.website": "Ιστοσελίδα",
    "detail.directions": "Οδηγίες",
    "detail.save": "Αποθήκευση",
    "detail.call": "Καλέστε μας",
    "detail.aboutTitle": "Τι μας ξεχωρίζει",
    "detail.readMore": "Διαβάστε περισσότερα",
    "detail.showLess": "Λιγότερα",
    "detail.openingHours": "Ωράριο λειτουργίας",
    "detail.closed": "Κλειστά",
    "detail.socialMedia": "Social Media",
    "detail.amenities": "Παροχές",
    "detail.upcomingEvents": "Επερχόμενα",
    "detail.pastEvents": "Προηγούμενα",

    "subcat.loadMore": "Περισσότερα",
    "subcat.allCities": "Όλες οι πόλεις",
    "subcat.empty": "Δεν υπάρχουν καταχωρήσεις",
    "subcat.emptyHint": "Δοκιμάστε άλλη πόλη ή επιστρέψτε αργότερα.",

    "fav.title": "Τα Αγαπημένα μου",
    "fav.subtitle": "Οι δραστηριότητες που αποθήκευσες.",
    "fav.empty": "Δεν έχεις αποθηκεύσει αγαπημένα ακόμη.",
    "fav.emptyHint": "Πάτα την καρδιά σε μια δραστηριότητα για να την αποθηκεύσεις εδώ.",
    "fav.browse": "Εξερεύνησε δραστηριότητες",
    "fav.saved": "Προστέθηκε στα αγαπημένα",
    "fav.removed": "Αφαιρέθηκε από τα αγαπημένα",

    "map.title": "Χάρτης Δραστηριοτήτων",
    "map.subtitle": "Δες όλες τις δραστηριότητες στον χάρτη και διάλεξε ό,τι είναι κοντά σου.",
    "map.filterLabel": "Κατηγορία",
    "map.cityLabel": "Πόλη",
    "map.allCategories": "Όλες οι κατηγορίες",
    "map.view": "Προβολή",
    "map.empty": "Δεν υπάρχουν δραστηριότητες με τοποθεσία για αυτό το φίλτρο.",

    "route.car": "Αυτοκίνητο",
    "route.foot": "Με τα πόδια",
    "route.you": "Η τοποθεσία σου",
    "route.locating": "Εντοπισμός της τοποθεσίας σου...",
    "route.denied": "Δεν έχουμε πρόσβαση στην τοποθεσία σου.",
    "route.retry": "Προσπάθησε ξανά",
    "route.openGoogle": "Άνοιγμα στο Google Maps",
  },
  en: {
    "nav.home": "Home",
    "nav.categories": "Categories",
    "nav.contact": "Contact",
    "nav.favorites": "Favorites",
    "nav.map": "Map",
    "nav.admin": "Admin",
    "nav.dashboard": "Dashboard",
    "nav.searchPlaceholder": "Search for an activity...",

    "home.title": "Find what suits you",
    "home.subtitle": "Pick a category and discover local activities & events.",
    "home.quickSearch": "Quick search",
    "home.allCities": "All cities",
    "home.allActivities": "All activities",
    "home.allSports": "All sports",
    "home.results": "Results",
    "home.noResults": "No results found for your criteria.",
    "home.offer": "Offer",
    "home.partnerTitle": "Become a partner",
    "home.partnerText": "Your business in a new digital ecosystem. Showcase your services and connect audiences with what you offer.",
    "home.partnerCta": "Learn more",
    "home.appTitle": "SkillCity, always with you.",
    "home.appSubtitle": "Discover activities, services and options for kids and adults, wherever you are.",
    "home.qrTitle": "Take SkillCity with you",
    "home.qrText": "Download the app for free on your phone.",

    "footer.tagline": "Local activities & events",
    "footer.follow": "Follow us",
    "footer.followTags": "News • Activities • Events • Tips",

    "contact.eyebrow": "Contact",
    "contact.title": "Get in touch",
    "contact.subtitle": "Have a question or want to list your activity? Send us a message.",
    "contact.emailLabel": "Email",
    "contact.areaLabel": "Area",
    "contact.areaValue": "Greece",
    "contact.hoursLabel": "Hours",
    "contact.hoursValue": "Mon–Fri 09:00–18:00",

    "form.name": "Name",
    "form.email": "Email",
    "form.subject": "Subject",
    "form.message": "Message",
    "form.send": "Send message",
    "form.sending": "Sending...",
    "form.success": "Your message has been sent! We'll be in touch soon.",
    "form.fail": "Failed to send",
    "subj.general": "General question",
    "subj.listing": "List an activity",
    "subj.partnership": "Partnership / Sponsorship",
    "subj.issue": "Report a problem",

    "detail.back": "Back",
    "detail.views": "views",
    "detail.schedule": "Weekly Schedule",
    "detail.reviews": "Reviews",
    "detail.addReview": "Add",
    "detail.noReviews": "No reviews yet. Be the first!",
    "detail.location": "Location",
    "detail.contactHeading": "Contact",
    "detail.notFound": "Activity not found.",
    "detail.return": "← Back",
    "detail.reviewTitle": "Add a review",
    "detail.reviewName": "Name",
    "detail.reviewRating": "Rating",
    "detail.reviewComment": "Comment",
    "detail.submit": "Submit",
    "detail.reviewAdded": "Your review has been submitted!",
    "detail.tabAbout": "About",
    "detail.tabDepartments": "Departments / Services",
    "detail.tabSchedule": "Schedule",
    "detail.tabFacilities": "Facilities",
    "detail.tabPhotos": "Photos",
    "detail.tabNews": "News / Events",
    "detail.tabOffers": "Offers",
    "detail.viewAllPhotos": "View all photos",
    "detail.reviewsWord": "reviews",
    "detail.website": "Website",
    "detail.directions": "Directions",
    "detail.save": "Save",
    "detail.call": "Call us",
    "detail.aboutTitle": "What makes us different",
    "detail.readMore": "Read more",
    "detail.showLess": "Show less",
    "detail.openingHours": "Opening hours",
    "detail.closed": "Closed",
    "detail.socialMedia": "Social Media",
    "detail.amenities": "Amenities",
    "detail.upcomingEvents": "Upcoming",
    "detail.pastEvents": "Past",

    "subcat.loadMore": "Load more",
    "subcat.allCities": "All cities",
    "subcat.empty": "No listings",
    "subcat.emptyHint": "Try another city or come back later.",

    "fav.title": "My Favorites",
    "fav.subtitle": "The activities you saved.",
    "fav.empty": "You haven't saved any favorites yet.",
    "fav.emptyHint": "Tap the heart on an activity to save it here.",
    "fav.browse": "Browse activities",
    "fav.saved": "Added to favorites",
    "fav.removed": "Removed from favorites",

    "map.title": "Activities Map",
    "map.subtitle": "See all activities on the map and pick what's near you.",
    "map.filterLabel": "Category",
    "map.cityLabel": "City",
    "map.allCategories": "All categories",
    "map.view": "View",
    "map.empty": "No activities with a location for this filter.",

    "route.car": "Driving",
    "route.foot": "Walking",
    "route.you": "Your location",
    "route.locating": "Finding your location...",
    "route.denied": "We can't access your location.",
    "route.retry": "Try again",
    "route.openGoogle": "Open in Google Maps",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("sc_lang") || "el");

  useEffect(() => {
    localStorage.setItem("sc_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => setLangState(l);
  const toggleLang = () => setLangState((l) => (l === "el" ? "en" : "el"));
  const t = (key) => (TRANSLATIONS[lang] && TRANSLATIONS[lang][key]) || TRANSLATIONS.el[key] || key;
  // Localized title for taxonomy objects ({ title, title_en })
  const tt = (obj) => {
    if (!obj) return "";
    return lang === "en" && obj.title_en ? obj.title_en : obj.title;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t, tt }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
